import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Insurance } from 'models/InsuranceModel';
import AsyncSelect from 'react-select/async';
import { useSearchParams } from 'react-router-dom';
import { handleIntakeAll } from 'helpers/forms/ExamHelper';

const InsuranceForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.INSURANCE, Code.Form.Name.INSURANCE];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [insurerOptions, setInsurerOptions] = Hooks.Form.Options();
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [primaryOptions, setPrimaryOptions] = Hooks.Form.Options();
  const [secondaryOptions, setSecondaryOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Insurance>({});

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
   
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.API(Code.File.INSURER, Code.Option.Common.SELECT, setInsurerOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.INSURANCE_TYPE, Code.Option.Common.NA, setTypeOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.INSURANCE_STATUS, Code.Option.Common.NA, setStatusOptions, setError);
    Files.Json.Http(Code.File.RELATION, Code.Option.Common.SELECT, setPrimaryOptions, setError);
    Files.Json.Http(Code.File.RELATION, Code.Option.Common.SELECT, setSecondaryOptions, setError);

    API.Data.GetByKeyId<Insurance>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.insurance_active); 
        const clientData = await API.Data.getClientNameNumber(data.client_id);
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
          ...clientData,
        }));
        setLoading(false);
      }})

      const onNewEntry = async () => {
        if(keyId===Code.Key.NEW && clientId) {
          const clientName = await API.Data.GetClientName(Number(clientId));
          setFormData((prevData) => ({
            ...prevData,
            client_id: Number(clientId),
            client_name: Utility.Value.Text(clientName), 
          }));
        }
        setLoading(false);
      };
      onNewEntry();
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
    });

    //console.log("insurance-final:",formData);

    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} clientNumber={formData.client_number} formName={formName} Privilege={Privilege}>
            <span className='fright pasteall' onClick={() => handleIntakeAll(setFormData)} title="Paste All Fields"></span>
          </Button.Save>
          <Control.Tab.Header titles={["Details","More"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Date id={Name.Insurance.Date} value={formData.insurance_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} currentDate={true} />
                <Field.Select id={Name.Common.TypeId} value={formData.type_id} title={Title.Type} options={typeOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Header id={Name.Client.Id} title={Title.Client} require={true}>
                  <AsyncSelect id={Name.Client.Id} loadOptions={(inputValue) => API.Data.ClientAsyncOption(inputValue, Code.Form.Name.CLIENT, Code.Mapping.client.value, Code.Mapping.client.label)} styles={Code.Style.SearchOption} onChange={(selected) => Utility.Handle.ClientChange(selected, setFormData)} value={Utility.Value.Async(formData.client_id,formData.client_name)} placeholder="Search" />
                </Field.Header>
                {/* <Field.Header id={Name.Client.Id} title={Title.Client} require={true}>
                  <AsyncSelect id={Name.Client.Id} .. loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.CLIENT, Code.Mapping.client.value, Code.Mapping.client.label)} styles={Code.Style.FormOption} onChange={(selected) => Utility.Handle.ClientChange(selected, setFormData)} value={Utility.Value.Async(formData.client_id,formData.client_name)} placeholder="Search" />
                </Field.Header> */}
              </Control.Row>
              <Control.Row>
              <Field.Text id={Name.Insurance.memberNumber} value={formData.insurance_member_number} title={Title.MemberNumber} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} />
              <Field.Text id={Name.Insurance.PolicyNumber} value={formData.insurance_policy_number} title={Title.PolicyNumber} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true}  />
              </Control.Row>
              <Control.Row>
                <Field.FilterSelect id={Name.Insurer.Id} value={formData.insurer_id} title={Title.Insurer} options={insurerOptions} setFormData={setFormData} size={[0,50,1]} require={true} />
                <Field.Text id={Name.Insurance.GroupNumber} value={formData.insurance_group_number} title="Group Number" onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]}  />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.Insurance.PrimaryHolderName} value={formData.primary_holder_name} title={Title.PrimaryHolder} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]}  />
                <Field.Text id={Name.Insurance.SecondaryHolderName} value={formData.secondary_holder_name} title={Title.SecondaryHolder} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
                </Control.Row>
              <Control.Row>
                <Field.FilterSelect id={Name.Insurance.PrimaryRelationship} value={formData.primary_relationship} title="Relation with Primary Holder" options={primaryOptions} setFormData={setFormData} size={[0,50,1]} />
                <Field.FilterSelect id={Name.Insurance.SecondaryRelationship} value={formData.secondary_relationship} title="Relation with Secondary Holder" options={secondaryOptions} setFormData={setFormData} size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Insurance.Comment} value={formData.insurance_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
            </Control.Tab.Content>

            <Control.Tab.Content id={Code.Tab.Tab2} isActive={activeTab === Code.Tab.Tab2}>
              <Control.Row>
                <Field.Date id={Name.Insurance.IssueDate} value={formData.insurance_issue_date} title={Title.Issue} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
                <Field.Date id={Name.Insurance.ExpiryDate} value={formData.insurance_expiry_date} title={Title.Expiry} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]}  />
              </Control.Row>
              <Control.Row>
                <Field.Select id={Name.Common.StatusId} value={formData.status_id} title={Title.Status} options={statusOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
                <Field.Text id={Name.Insurance.RefNumber} value={formData.insurance_ref_number} title={Title.Refno} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
            </Control.Tab.Content>
            
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default InsuranceForm;